import React from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import Header from "../../components/ui/Header";
import ChapterController from "../../components/ui/ChapterController";

const ComicReader: React.FC = () => {
  const { lang, slug, chapterIndex } = useParams<{
    lang: string;
    slug: string;
    chapterIndex: string;
  }>();
  const location = useLocation();
  const navigate = useNavigate();
  // Nhận detail và chapters từ location.state
  const { detail, chapters } = location.state || {};
  const chaptersArr = chapters || [];
  const currentIdx = Number(chapterIndex);
  const currentChapter = chaptersArr.find((c: any) => c.index === currentIdx);

  // Lấy trạng thái hideUI từ ChapterController (giả sử ChapterController truyền prop hoặc context)
  const [hideUI, setHideUI] = React.useState(false);

  // Điều hướng sang chapter trước/sau
  const goToChapter = (idx: number) => {
    const chapter = chaptersArr.find((c: any) => c.index === idx);
    if (!chapter) return;
    window.scrollTo({ top: 0 }); // Scroll lên đầu khi chuyển trang
    navigate(`/${lang}/comic/${slug}/${idx}/`, {
      state: { detail, chapters },
    });
  };

  if (!detail || !currentChapter)
    return <div className="text-white p-8">Không tìm thấy chương truyện.</div>;
  console.log('sasaas:',currentChapter.content);
  
  return (
    <div className="comic-reader bg-mainBlack min-h-screen text-white relative">
      {/* Header ẩn/hiện */}
      {!hideUI && <Header isBack/>}
      <div className="max-w-2xl mx-auto pt-8 pb-24">
        <h1 className="text-2xl font-bold mb-2 text-center">{detail.title}</h1>
        <div className="mb-4 text-center text-lg">
          Chương {currentChapter.index}: {currentChapter.title || ""}
        </div>
        <div className="chapter-content bg-gray-900 rounded p-4 min-h-[300px] mb-8">
          {/* Hiển thị nội dung chương dạng array image */}
          {Array.isArray(currentChapter.content) ? (
            <div className="flex flex-col gap-4 items-center">
              {currentChapter.content.map((img: string, i: number) => (
                <img
                  key={i}
                  src={img}
                  alt={`page-${i + 1}`}
                  className="w-full max-w-[900px] rounded shadow object-contain"
                  loading="lazy"
                  style={{ background: "#222" }}
                />
              ))}
            </div>
          ) : (
            <div
              dangerouslySetInnerHTML={{
                __html: currentChapter.content || "Không có nội dung chương này."
              }}
            />
          )}
        </div>
      </div>
      {/* Controller chapter và drawer */}
      <ChapterController
        currentIdx={currentIdx}
        chaptersArr={chaptersArr}
        goToChapter={goToChapter}
        slug={slug || ""}
        currentChapter={currentChapter}
        type="comic"
        setHideUI={setHideUI}
        hideUI={hideUI}
      />
    </div>
  );
};

export default ComicReader;
